import { Component, OnInit, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { AuthenticationService } from "../../services/authentication/authentication.service";
import { LayoutService } from "../../services/layouts/layout.service";
import { Translator } from "@sharedV11/services/translator/translator.service";
import { userResponse } from "../../classes/userResponse/user-response";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

interface NavigateElemente {
  targetRoute: string;
  childNameKeyTranslate: string;
  traduccionesEntry: TraductionEntry;
  defaultParentMenuElement: DefaultParentMenuElment
}

interface TraductionEntry {
  id: string;
  texto: string;
  icono: string;
  route: string;
}
interface DefaultParentMenuElment {
  id: string;
  texto: string;
  icono: string;
  submenu: TraductionEntry[];
}


@Component({
  selector: "app-sidemenu",
  templateUrl: "./sidemenu.component.html",
  styleUrls: ["./sidemenu.component.scss"],
})
export class SidemenuComponent implements OnInit, OnDestroy {
  menuDevelopment: any = [];
  logueado: boolean;
  Botones;
  Version: string;
  events: string[] = [];
  opened: boolean;
  modelo = [];
  submenuTitulo = "";
  layoutservices: LayoutService;
  translateData: any;
  private ngUnsubscribe = new Subject<void>();

  parentLabelsOfConfiguracionProyecto = [
      "CONFIGURACIÓN DEL PROYECTO",
      "CONFIGURACION DEL PROYECTO",
      "CONFIGURACIÓN",
      "CONFIGURACION",
    ];

  isConfiguracionProyecto(texto: string): boolean {
    if (!texto || typeof texto !== "string") return false;
    return this.parentLabelsOfConfiguracionProyecto.indexOf(texto.trim().toUpperCase()) !== -1;
  }

  constructor(
    private autentificador: AuthenticationService,
    private router: Router,
    private _ruta: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private _layoutservices: LayoutService,
    private translator: Translator,
    private cdr: ChangeDetectorRef
  ) {
    this.layoutservices = _layoutservices;
  }

  ngOnInit(): void {
    this.translateData = this.translator.GetTranslations();

    // Escutar mudanças de idioma do backend
    this.translator.dataLanguage$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        if (data) {
          this.translateData = this.translator.GetTranslations();
          if (this.logueado && this.Botones) {
            this.recreateConfiguracionMenus();
          }
          this.cdr.detectChanges();
        }
      });

    if (!environment.production) {
      this.initializeDataListDevelopment();
    }

    // this.Version = environment.version;
    this.logueado = !this.autentificador.ocultarMenusQueryString(this._ruta);
    if (this.logueado) {
      this.Botones = this.autentificador.getPermisosComoBotones();
      
      // Garantir que Botones seja um array
      if (!Array.isArray(this.Botones)) {
        this.Botones = [];
      }
      
      // CRÍTICO: Remover itens de configuración de outros menus ANTES de qualquer outra manipulação
      // Isso garante que mesmo se o backend retornar os itens dentro de "Maestros", eles serão movidos
      this.removeConfiguracionItemsFromOtherMenus();
      
      // Agora garantir que os menus de configuración sejam criados
      // Primeiro criar/garantir o menu pai, depois adicionar os filhos
      // skipRemoval=true porque já removemos acima
      this.ensureConfiguracionProyectoMenu(true);
      this.ensureTraduccionesMenuEntry();
      
      // Depois de criar os menus de configuración, fazer outras manipulações
      this.injectAccessControlKuroiMenu();
      
      // Forçar detecção de mudanças após criar os menus
      this.cdr.detectChanges();
      
      // Verificar se ainda há itens de configuración em outros menus (fallback)
      this.Botones.forEach((menu) => {
        if (menu.texto && menu.texto.toUpperCase() !== 'CONFIGURACIÓN DEL PROYECTO' && menu.texto.toUpperCase() !== 'CONFIGURACION DEL PROYECTO') {
          if (Array.isArray(menu.submenu)) {
            const configItems = menu.submenu.filter(sub => {
              const route = (sub?.route || "").trim().toLowerCase();
              return route === '/configuracion/traducciones' || 
                     route === '/configuracion/impresiononline' ||
                     route === 'configuracion/traducciones' ||
                     route === 'configuracion/impresiononline';
            });
            if (configItems.length > 0) {
              // Tentar remover novamente (fallback)
              const reRemoved = this.removeConfiguracionItemsFromOtherMenus();
              if (reRemoved.length > 0) {
                // skipRemoval=false porque precisamos remover novamente no fallback
                this.ensureConfiguracionProyectoMenu(false);
                this.ensureTraduccionesMenuEntry();
                this.cdr.detectChanges();
              }
            }
          }
        }
      });
      
      // Verificação final: garantir que o menu Configuración existe e tem os submenus
      const finalConfigMenu = this.Botones.find(m => 
        m.id === 'configuracion-del-proyecto' || 
        (m.texto && this.parentLabelsOfConfiguracionProyecto.indexOf(m.texto.toUpperCase()) !== -1)
      );
      
      if (!finalConfigMenu) {
        // skipRemoval=true porque já tentamos remover antes
        this.ensureConfiguracionProyectoMenu(true);
        this.ensureTraduccionesMenuEntry();
        this.cdr.detectChanges();
      } else {
        const hasTraducciones = finalConfigMenu.submenu && finalConfigMenu.submenu.some(s => 
          (s.route || "").toLowerCase().includes('traducciones')
        );
        const hasImpresionOnline = finalConfigMenu.submenu && finalConfigMenu.submenu.some(s => 
          (s.route || "").toLowerCase().includes('impresiononline')
        );
        
        if (!hasTraducciones || !hasImpresionOnline) {
          // skipRemoval=true porque o menu já existe, só precisamos adicionar os submenus
          this.ensureConfiguracionProyectoMenu(true);
          this.ensureTraduccionesMenuEntry();
          this.cdr.detectChanges();
        }
      }
      
      // if (this.Botones.length === 0) {
      //   //this.router.navigate(['login']);
      // } else {
      // }
    }

    this.layoutservices.urlclicked
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((u) => {
        if (u && u !== undefined) this.clicksubmenu(u);
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  /**
   * Recria os menus de configuración quando o idioma muda
   * Usa exatamente os nomes que vêm da API, sem forçar traduções
   */
  private recreateConfiguracionMenus(): void {
    // Buscar o nome do módulo 223 da API
    const nombreModuloAPI = this.getNombreModuloFromAPI(223);
    
    // Atualizar o texto do menu pai se existir
    const configMenu = this.Botones.find(
      (menu) => menu.id === "configuracion-del-proyecto" ||
                (menu.texto && menu.texto.toUpperCase().includes("CONFIGURACION"))
    );

    if (configMenu && nombreModuloAPI) {
      // Atualizar o texto do menu pai com o nome da API
      configMenu.texto = nombreModuloAPI;

      // Atualizar textos dos submenus com os nomes da API
      if (Array.isArray(configMenu.submenu)) {
        configMenu.submenu.forEach((submenu) => {
          if (submenu.route === "/configuracion/traducciones") {
            const nombreAPI = this.getNombreSubmenuFromAPI("/configuracion/traducciones");
            if (nombreAPI) {
              submenu.texto = nombreAPI;
            }
          } else if (submenu.route === "/configuracion/ImpresionOnline") {
            const nombreAPI = this.getNombreSubmenuFromAPI("/configuracion/ImpresionOnline");
            if (nombreAPI) {
              submenu.texto = nombreAPI;
            }
          }
        });
      }
    }

    // Garantir que os menus existam (caso tenham sido removidos)
    // skipRemoval=true porque estamos apenas recriando após mudança de idioma
    this.ensureConfiguracionProyectoMenu(true);
    this.ensureTraduccionesMenuEntry();
  }

  private injectAccessControlKuroiMenu(): void {
    if (!this.Botones || !Array.isArray(this.Botones)) {
      return;
    }

    const maestrosSection = this.Botones.find((item) => {
      if (!Array.isArray(item?.submenu)) {
        return false;
      }
      const hasMaestrosRoute = item.submenu.some((submenuItem) =>
        (submenuItem?.route ?? "").toLowerCase().startsWith("/maestros/")
      );
      const isMaestrosLabel =
        item?.texto?.toLowerCase?.() === "maestros" ||
        item?.texto?.toLowerCase?.() ===
          (this.translateData?.Maestros?.toLowerCase?.() ?? "");
      return hasMaestrosRoute || isMaestrosLabel;
    });

    if (!maestrosSection || !Array.isArray(maestrosSection.submenu)) {
      return;
    }

    const alreadyExists = maestrosSection.submenu.some(
      (submenuItem) =>
        submenuItem?.route?.toLowerCase() ===
        "/maestros/accesos".toLowerCase()
    );

    if (!alreadyExists) {
      maestrosSection.submenu.push({
        texto:
          this.translateData?.ControlAccesos ?? this.translateData?.ControlAccesosKuroi ?? "Control Accesos",
        route: "/Maestros/Accesos",
      });
    }
  }

  async initializeTranslate() {
    let lang = this.translator.getLocale() || "es-ES";
    this.translateData = this.translator.GetTranslations();

    if (!localStorage.getItem("Language")) {
      localStorage.setItem("Language", lang);
    }
    if (localStorage.getItem("Language")) {
      lang = localStorage.getItem("Language");
    }

    this.translator.setLocale(lang);
    await this.translator.use(lang).then((data) => {
      if (data) {
        this.translateData = data;
      }
    });
  }

  initializeDataListDevelopment() {
    this.menuDevelopment = [
      {
        name: "Espacios",
        subMenu: [
          { name: "Espectáculos", route: "/Recintos/Espectaculos" },
          {
            name: "Sesiones con Butacas",
            route: "/Recintos/SesionesConButaca",
          },
        ],
      },
      {
        name: "Codigos Promocionales",
        subMenu: [
          {
            name: "CodigoPromocional",
            route: "/CodigosPromocionales/CodigoPromocional",
          },
          {
            name: "TipoCodigoPromocional",
            route: "/CodigosPromocionales/TipoCodigoPromocional",
          },
          {
            name: "CodigoPromocionalBines",
            route: "/CodigosPromocionales/CodigoPromocionalBines",
          }
        ],
      } /*
      {"name":"Clientes V11","subMenu":[
        {"name":"Cliente V11","route":"/Clientes/ClienteV11"},
        {"name":"Client Group V11","route":"/Clientes/GrupoClienteV11"},
        {"name":"Formas de Pago V11","route":"/Clientes/FormasPagoV11"}


      ]},
      {"name":"Maestros V11","subMenu":[
        {"name":"Type access control  V11","route":"/Maestros/TypeAccessControlV11"}

      ]},*/,
      {
        name: "Tarifas",
        subMenu: [
          {
            name: "Tipo Reserva",
            route: "/Tarifas/TipoReserva"
          },
          {
            name: "Temporadas Tarifas",
            route: "/Tarifas/TemporadaTarifas"
          },
          {
            name: "Grupos Tarifas",
            route: "/Tarifas/GruposTarifas"
          }
        ],
      },
      {
        name: "Tienda",
        subMenu: [
          {
            name: "Proveedores",
            route: "/tienda/Proveedores"
          },
          {
            name: "Productos",
            route: "/tienda/ProductosTienda"
          },
          {
            name: "Productos Promociones",
            route: "/tienda/ProductosPromociones"
          },
          {
            name: "Gestión de Inventario",
            route: "/tienda/gestioninventario"
          },
        ],
      },
      {
        name: 'Entradas y Promociones',
        subMenu: [
          {
            name: 'Reglas de negocio',
            route: '/EntradasPromociones/ReglasNegocio'
          }
        ]
      },
      {
        name: 'Maestros',
        subMenu: [
          {
            name: 'Jerarquía de Categorias',
            route: '/Maestros/CategoriasJerarquicas'
          },
          {
            name: 'Schemas',
            route: '/Maestros/schemas'
          }
        ]
      },
      {
        name: 'Configuración del proyecto',
        subMenu: [
          {
            name: 'Enlaces menú',
            route: '/configuracion/enlacemenu'
          },
           {
            name: 'Tipos de Usuarios',
            route: '/Usuario/TiposUsuarios'
          }
        ]
      }
    ];
  }

  clicksubmenu(ruta) {
    var allRoutes: string[] = [];

    for (var i = 0; i < this.router.config.length; i++) {
      allRoutes.push(this.router.config[i].path);
    }
    for (var i = 0; i < this.router.config[0].children.length; i++) {
      allRoutes.push(this.router.config[0].children[i].path);
      if (this.router.config[0].children[i].children) {
        for (
          var j = 0;
          j < this.router.config[0].children[i].children.length;
          j++
        ) {
          allRoutes.push(
            this.router.config[0].children[i].path +
              "/" +
              this.router.config[0].children[i].children[j].path
          );
        }
      }
    }

    if (allRoutes.find((x) => "/" + x == ruta)) {
      this.router.navigate([ruta]);
    } else {
      this.openSnackBar(this.translateData["Nodisponible"], this.translateData["Aceptar"]);
    }
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2500,
      panelClass: ["blue-snackbar"],
      horizontalPosition: "center",
      verticalPosition: "top",
    });
  }

  /**
   * Encontra o menu pai de "Configuración del Proyecto" baseado no texto ou no nome da API
   * NÃO por rotas, para evitar encontrar "Maestros" incorretamente
   */
  private findConfiguracionParentMenu(): any {
    if (!this.Botones || !Array.isArray(this.Botones)) {
      return null;
    }

    // Primeiro, buscar o nome correto da API para o módulo 223
    const nombreModuloAPI = this.getNombreModuloFromAPI(223);

    const parentLabels = [
      "CONFIGURACIÓN DEL PROYECTO",
      "CONFIGURACION DEL PROYECTO",
      "CONFIGURACIÓN",
      "CONFIGURACION",
    ];

    // Se temos o nome da API, tentar encontrar pelo nome exato da API primeiro
    if (nombreModuloAPI) {
      const parentMenuByAPI = this.Botones.find(
        (menu) => (menu?.texto || "").trim().toUpperCase() === nombreModuloAPI.trim().toUpperCase()
      );
      if (parentMenuByAPI) {
        return parentMenuByAPI;
      }
    }

    // Depois, tenta encontrar pelo texto traduzido (compatibilidade)
    const parentMenuByText = this.Botones.find(
      (menu) => parentLabels.indexOf((menu?.texto || "").toUpperCase()) !== -1
    );

    if (parentMenuByText) {
      return parentMenuByText;
    }

    // Tenta encontrar pela chave de tradução traduzida
    if (this.translateData && this.translateData["Configuración del proyecto"]) {
      const translatedText = this.translateData["Configuración del proyecto"];
      const parentMenuByTranslated = this.Botones.find(
        (menu) => (menu?.texto || "").toUpperCase() === translatedText.toUpperCase()
      );
      if (parentMenuByTranslated) {
        return parentMenuByTranslated;
      }
    }

    // NÃO procurar por rotas aqui, pois isso pode encontrar "Maestros" incorretamente
    // Se não encontrou pelo texto, retorna null para criar um novo menu
    return null;
  }

  /**
   * Remove itens de configuración de outros menus (como Maestros) e retorna os itens removidos
   * Este método é CRÍTICO e deve ser executado ANTES de qualquer outra manipulação do menu
   * Também coleta itens órfãos que podem ter sido criados sem um menu pai
   */
  private removeConfiguracionItemsFromOtherMenus(): any[] {
    if (!this.Botones || !Array.isArray(this.Botones)) {
      return [];
    }

    // Rotas conhecidas de configuración (incluindo variações)
    const configuracionRoutes = [
      "/configuracion/traducciones",
      "/configuracion/ImpresionOnline",
      "/configuracion/traducciones/",
      "/configuracion/ImpresionOnline/",
      "configuracion/traducciones",
      "configuracion/ImpresionOnline",
      "/configuracion/calendarioscuadrosmes",
      "/configuracion/enlacemenu"
    ];

    // Nomes de texto que podem indicar itens de configuración
    const configuracionTextos = [
      "traducciones",
      "traducciones y textos",
      "idiomas recursos",
      "impresiononline",
      "impresion online",
      "listados",
      "calendario cuadro mes",
      "enlaces menu"
    ];

    const removedItems = [];
    let totalRemoved = 0;

    this.Botones.forEach((menu, menuIndex) => {
      // Ignorar se este menu já é o menu "Configuración del proyecto"
      const isConfiguracionMenu = menu.id === "configuracion-del-proyecto" ||
        (menu.texto && this.parentLabelsOfConfiguracionProyecto.indexOf(menu.texto.toUpperCase()) !== -1);
      
      if (isConfiguracionMenu) {
        return;
      }

      if (Array.isArray(menu?.submenu)) {
        // Filtrar itens de configuración do submenu
        const itemsToRemove = menu.submenu.filter((submenu) => {
          const route = (submenu?.route || "").trim().toLowerCase();
          const texto = (submenu?.texto || "").trim().toLowerCase();
          
          // Verificar por rota
          const matchesRoute = configuracionRoutes.some(configRoute => 
            route === configRoute.toLowerCase() ||
            route.endsWith(configRoute.toLowerCase()) ||
            route.startsWith("/configuracion/") ||
            route.startsWith("configuracion/")
          );
          
          // Verificar por texto (caso a rota não esteja presente ou seja diferente)
          const matchesTexto = configuracionTextos.some(configTexto => 
            texto.includes(configTexto.toLowerCase())
          );
          
          return matchesRoute || matchesTexto;
        });

        if (itemsToRemove.length > 0) {
          // Adicionar aos itens removidos (criar cópia para evitar referências)
          // Usar exatamente o que vem da API, sem forçar nomes ou traduções
          itemsToRemove.forEach(item => {
            removedItems.push({
              id: item.id || `config-${(item.route || "").replace(/\//g, '-')}`,
              texto: item.texto || "", // Usar o texto que já vem do backend
              icono: item.icono || "settings",
              route: item.route
            });
          });
          
          // Remover do submenu
          menu.submenu = menu.submenu.filter((submenu) => {
            const route = (submenu?.route || "").trim().toLowerCase();
            const texto = (submenu?.texto || "").trim().toLowerCase();
            
            const matchesRoute = configuracionRoutes.some(configRoute => 
              route === configRoute.toLowerCase() ||
              route.endsWith(configRoute.toLowerCase()) ||
              route.startsWith("/configuracion/") ||
              route.startsWith("configuracion/")
            );
            
            const matchesTexto = configuracionTextos.some(configTexto => 
              texto.includes(configTexto.toLowerCase())
            );
            
            return !(matchesRoute || matchesTexto);
          });
          
          totalRemoved += itemsToRemove.length;
        }
      }
    });

    // Também verificar se há itens órfãos no nível raiz (não deveria acontecer, mas por segurança)
    const orphanItems = this.Botones.filter((menu) => {
      if (!menu.submenu || !Array.isArray(menu.submenu)) {
        return false;
      }
      const route = (menu.route || "").trim().toLowerCase();
      return route.startsWith("/configuracion/") || route.startsWith("configuracion/");
    });


    return removedItems;
  }

  /**
   * Busca o nome do módulo nas permissões originais da API
   * @param moduloId ID do módulo a buscar
   * @returns Nome do módulo na linguagem atual (NombreModuloIdioma) ou NombreModulo como fallback, ou null
   */
  private getNombreModuloFromAPI(moduloId: number | string): string | null {
    try {
      if (sessionStorage.getItem("currentUser") != null) {
        const userResp = new userResponse();
        const permisos = userResp.deserialize(
          JSON.parse(sessionStorage.getItem("currentUser"))
        ).DatosResult.Permisos;
        
        const modulo = permisos.find(
          (p) => p.ModuloId == moduloId && p.NombreAccion.trim().toUpperCase() == "VER"
        );
        
        if (modulo) {
          // Se NombreModuloIdioma está vazio, usar NombreModulo como fallback
          return modulo.NombreModuloIdioma && modulo.NombreModuloIdioma.trim() !== "" 
            ? modulo.NombreModuloIdioma 
            : modulo.NombreModulo || null;
        }
      }
    } catch (error) {
      // Silenciosamente retorna null em caso de erro
    }
    return null;
  }

  /**
   * Garante que existe um menu "Configuración del proyecto" e adiciona os itens de configuración
   * @param skipRemoval Se true, não remove itens de outros menus (útil quando já foi removido anteriormente)
   */
  private ensureConfiguracionProyectoMenu(skipRemoval: boolean = false): any {
    if (!this.Botones || !Array.isArray(this.Botones)) {
      return null;
    }

    // Remover itens de configuración de outros menus (como Maestros) apenas se não foi pulado
    const removedItems = skipRemoval ? [] : this.removeConfiguracionItemsFromOtherMenus();

    // Tentar encontrar o menu "Configuración del proyecto" existente
    const parentMenu = this.findConfiguracionParentMenu();

    if (parentMenu) {
      // Atualizar o texto do menu pai com o nome da API (se necessário)
      const nombreModulo = this.getNombreModuloFromAPI(223);
      if (nombreModulo && parentMenu.texto !== nombreModulo) {
        parentMenu.texto = nombreModulo;
      }
      
      // Adicionar itens removidos de outros menus ao menu existente
      if (removedItems.length > 0) {
        if (!parentMenu.submenu) {
          parentMenu.submenu = [];
        }
        removedItems.forEach((item) => {
          const alreadyExists = parentMenu.submenu.some(
            (submenu) => submenu.route === item.route
          );
          if (!alreadyExists) {
            parentMenu.submenu.push(item);
          }
        });
      }
      return parentMenu;
    }

    // Buscar o nome do módulo "Configuración" (ModuloId: 223) na API
    // Usar exatamente o que vem da API: NombreModuloIdioma se disponível, senão NombreModulo
    const nombreModulo = this.getNombreModuloFromAPI(223);
    // Se não encontrar na API, usar "CONFIGURACION" como último recurso (valor padrão da API)
    const textoMenu = nombreModulo || "CONFIGURACION";

    // Se não existe, criar um novo
    const newParentMenu = {
      id: "configuracion-del-proyecto",
      texto: textoMenu,
      icono: "settings",
      submenu: [],
    };

    // Adicionar itens removidos de outros menus
    if (removedItems.length > 0) {
      newParentMenu.submenu = removedItems;
    }

    // Verificar se já existe um menu com esse ID antes de adicionar
    const existingMenu = this.Botones.find((menu) => menu.id === newParentMenu.id);
    if (!existingMenu) {
      this.Botones.push(newParentMenu);
      return newParentMenu;
    } else {
      // Atualizar o texto se necessário
      if (nombreModulo && existingMenu.texto !== nombreModulo) {
        existingMenu.texto = nombreModulo;
      }
      // Adicionar itens removidos ao menu existente
      if (!existingMenu.submenu) {
        existingMenu.submenu = [];
      }
      removedItems.forEach((item) => {
        const alreadyExists = existingMenu.submenu.some(
          (submenu) => submenu.route === item.route
        );
        if (!alreadyExists) {
          existingMenu.submenu.push(item);
        }
      });
      return existingMenu;
    }
  }

  /**
   * Verifica se o usuário tem permissão VER para uma rota específica
   * @param route Rota a verificar
   * @returns true se o usuário tem permissão VER, false caso contrário
   */
  private hasPermissionForRoute(route: string): boolean {
    try {
      if (sessionStorage.getItem("currentUser") != null) {
        const userResp = new userResponse();
        const permisos = userResp.deserialize(
          JSON.parse(sessionStorage.getItem("currentUser"))
        ).DatosResult.Permisos;
        const modulo = permisos.find(
          (p) => p.Ventana && p.Ventana.trim().toLowerCase() === route.trim().toLowerCase() && 
                 p.NombreAccion.trim().toUpperCase() == "VER"
        );
        return modulo != null;
      }
    } catch (error) {
      // Silenciosamente retorna false em caso de erro
    }
    return false;
  }

  /**
   * Busca o nome de um submenu nas permissões originais da API baseado na rota
   * @param route Rota do submenu
   * @returns Nome do módulo na linguagem atual (NombreModuloIdioma) ou NombreModulo como fallback, ou null
   */
  private getNombreSubmenuFromAPI(route: string): string | null {
    try {
      if (sessionStorage.getItem("currentUser") != null) {
        const userResp = new userResponse();
        const permisos = userResp.deserialize(
          JSON.parse(sessionStorage.getItem("currentUser"))
        ).DatosResult.Permisos;
        
        const modulo = permisos.find(
          (p) => p.Ventana && p.Ventana.trim().toLowerCase() === route.trim().toLowerCase() && 
                 p.NombreAccion.trim().toUpperCase() == "VER"
        );
        
        if (modulo) {
          // Se NombreModuloIdioma está vazio, usar NombreModulo como fallback
          return modulo.NombreModuloIdioma && modulo.NombreModuloIdioma.trim() !== "" 
            ? modulo.NombreModuloIdioma 
            : modulo.NombreModulo || null;
        }
      }
    } catch (error) {
      // Silenciosamente retorna null em caso de erro
    }
    return null;
  }

  private ensureTraduccionesMenuEntry(): void {
    if (!this.Botones || !Array.isArray(this.Botones)) {
      return;
    }

    const targetRoute = "/configuracion/traducciones";
    
    // Verificar se o usuário tem permissão VER para esta rota
    if (!this.hasPermissionForRoute(targetRoute)) {
      return;
    }
    const routeVariations = [
      "/configuracion/traducciones",
      "configuracion/traducciones",
      "/configuracion/traducciones/",
      "configuracion/traducciones/"
    ];
    
    // Garantir que o menu "Configuración del proyecto" existe
    const parentMenu = this.ensureConfiguracionProyectoMenu(true);
    
    if (!parentMenu) {
      return;
    }

    if (!parentMenu.submenu) {
      parentMenu.submenu = [];
    }

    // Verificar se o item já existe (por rota ou por texto)
    const existingItem = parentMenu.submenu.find((submenu) => {
      const route = (submenu?.route || "").trim().toLowerCase();
      const texto = (submenu?.texto || "").trim().toLowerCase();
      return routeVariations.some(variation => route === variation.toLowerCase() || route.endsWith(variation.toLowerCase())) ||
             texto.includes("traducciones") || texto.includes("idiomas recursos");
    });

    if (existingItem) {
      // Buscar o nome correto da API e atualizar se necessário
      const nombreAPI = this.getNombreSubmenuFromAPI(targetRoute);
      if (nombreAPI && existingItem.texto !== nombreAPI) {
        existingItem.texto = nombreAPI;
      }
      if (!routeVariations.some(variation => (existingItem.route || "").trim().toLowerCase() === variation.toLowerCase())) {
        existingItem.route = targetRoute;
      }
      return;
    }

    // Buscar o nome da API - usar exatamente o que vem da API
    const nombreAPI = this.getNombreSubmenuFromAPI(targetRoute);
    // Se não encontrar na API, deixar vazio (não forçar nomes fixos)
    const textoFinal = nombreAPI || "";

    const traduccionesEntry = {
      id: "configuracion-traducciones",
      texto: textoFinal,
      icono: "translate",
      route: targetRoute,
    };

    parentMenu.submenu.push(traduccionesEntry);
  }

  private ensureMaestrosMenuEntries(): void {
    if (!this.Botones || !Array.isArray(this.Botones)) {
      return;
    }

    const maestrosSection = this.Botones.find(
      (menu) => (menu?.texto || "").toUpperCase() === "MAESTROS"
    );

    if (maestrosSection) {
      const controlAccesosKuroiEntry = {
        id: "maestros-control-accesos-kuroi",
        texto:
          this.translateData?.["Control Accesos"] ||
          "Control Accesos",
        icono: "security",
        route: "/Maestros/ControlAccesos",
      };

      const lugaresEntry = {
        id: "maestros-lugares",
        texto: this.translateData?.["Lugares"] || "Lugares",
        icono: "place",
        route: "/Maestros/Lugares",
      };

      const alreadyExistsKuroi =
        maestrosSection.submenu &&
        maestrosSection.submenu.some(
          (submenu) => submenu.route === controlAccesosKuroiEntry.route
        );

      if (!alreadyExistsKuroi) {
        maestrosSection.submenu = [
          ...(maestrosSection.submenu || []),
          controlAccesosKuroiEntry,
        ];
      }

      const alreadyExistsLugares =
        maestrosSection.submenu &&
        maestrosSection.submenu.some(
          (submenu) => submenu.route === lugaresEntry.route
        );

      if (!alreadyExistsLugares) {
        maestrosSection.submenu = [
          ...(maestrosSection.submenu || []),
          lugaresEntry,
        ];
      }
    }
  }

  private insertParentMenuWithChild(entryData: NavigateElemente): void {
    if (!this.Botones || !Array.isArray(this.Botones)) {
      return;
    }

    const targetRoute = entryData.targetRoute;

    this.Botones.forEach((menu) => {
      if (Array.isArray(menu?.submenu)) {
        menu.submenu.forEach((submenu) => {
          if (submenu.route === targetRoute) {
            // Usar a chave de tradução diretamente, o pipe translateV2 no template fará a tradução
            submenu.texto = entryData.childNameKeyTranslate;
          }
        });
      }
    });

    // Usa a função auxiliar para encontrar o menu pai baseado em rotas, não apenas texto
    const parentMenu = this.findConfiguracionParentMenu();

    const traduccionesEntry = { ...entryData.traduccionesEntry };

    if (parentMenu) {
      const alreadyExists =
        parentMenu.submenu &&
        parentMenu.submenu.some((submenu) => submenu.route === targetRoute);

      if (!alreadyExists) {
        if (!parentMenu.submenu) {
          parentMenu.submenu = [];
        }
        parentMenu.submenu = [...parentMenu.submenu, traduccionesEntry];
      }
    } else {
      // Criar o menu pai se não existir
      const existingMenu = this.Botones.find(
        (menu) => menu.id === entryData.defaultParentMenuElement.id
      );
      if (!existingMenu) {
        this.Botones.push(entryData.defaultParentMenuElement);
      } else {
        // Se existe, adicionar o item ao submenu existente
        if (!existingMenu.submenu) {
          existingMenu.submenu = [];
        }
        const alreadyExistsInExisting = existingMenu.submenu.some(
          (submenu) => submenu.route === targetRoute
        );
        if (!alreadyExistsInExisting) {
          existingMenu.submenu.push(traduccionesEntry);
        }
      }
    }
  }
}
